export var _ITEM_ID_ = '_id_';
export var _ITEM_DATA_ = '_data_';
export var _ITEM_VALUE_ = '_value_';
export var _ITEM_INDEX_ = '_index_';
export var _ITEM_PATH_ = '_path_';
export var _ITEM_CHILDREN_ = '_children_';
export var VARIABLE_FORMAT_REGEX = /\{(.*?)\}/g;